import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { ProjectStudiesStore } from '../stores/project-studies.store';
import { isNewStudyPageEnabled } from '../utils/new-study-page';
import { routeParamFromRoot } from './route-param';

/**
 * Loads a unit — with its containing subcategory — into `ProjectStudiesStore` before a unit-level page
 * renders under a study (`GET …/unit/{unitId}`, P1-CONSUMERS.md D8), so `StudyFacade.selectedUnit$`,
 * `getSubcategoryIdByUnitId` and the other synchronous unit reads answer as they did off the embedded
 * tree. A no-op while the legacy page is on, and on the selection side, where there is no study.
 */
export const studyUnitResolver: ResolveFn<boolean> = route => {
  if (!isNewStudyPageEnabled()) {
    return true;
  }
  const studyId = routeParamFromRoot(route, 'studyId');
  const unitId = routeParamFromRoot(route, 'unitId');
  if (!studyId || !unitId) {
    return true;
  }
  return inject(ProjectStudiesStore)
    .ensureUnit(studyId, unitId)
    .pipe(
      map(() => true),
      catchError(() => of(true))
    );
};
